import CreateCowModal from "./create-cow-modal.vue";

export default CreateCowModal;



// WEBPACK FOOTER //
// ./src/components/_modals/create-cow/index.js